// extracted by mini-css-extract-plugin
export default {"error":"vfYev","refresh":"njx00","name":"mpaPn"};